import basicRest from '../common/CommonRestFunctions'

const baseCommodityUrl = '/commodity-stock'

export default {
  getCommodities (filter) {
    return basicRest.executeBasicAxiosGet(`${baseCommodityUrl}/list/${filter.page}/${filter.processId}`)
  },
  filterCommodities (filters) {
    return basicRest.executeBasicAxiosPost(baseCommodityUrl + '/filter', filters)
  }
}
